import { Routes } from '@angular/router'
import { RegistrationAccountComponent } from './views/account/registration-account/registration-account.component'
import { WelcomeComponent } from './views/welcome/welcome.component'

export const routes: Routes = [
  {
    path: 'welcome',
    title: 'Top',
    component: WelcomeComponent,
  },
  {
    path: '',
    component: WelcomeComponent,
  },
  {
    path: 'register-account',
    title: 'アカウント登録',
    component: RegistrationAccountComponent,
  },
]
